/** @format */

const template = `
<div class="show-module-content-application-modal">
  <div class="modal-header">
    <button type="button" class="modal-close" ng-click="$ctrl.close()" aria-label="{{'ARIA_LABEL.CLOSE' | translate}}">
      <sis-icon icon="ring-close"></sis-icon>
    </button>
    <h2
      ><span
        class="modal-title"
        translate="{{'HANDLE_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.approvalRequest.type + '.MODAL_TITLE'}}"
        translate-value-module-name="{{$ctrl.module.name|localizedString}}"
        >Hyväksyntäanomus poikkeukselliselle suoritustavalle</span
      >
      <student-application-state-badge state="$ctrl.approvalRequest.state" badge-class="$ctrl.badgeClass"></student-application-state-badge
    ></h2>
  </div>
  <div class="modal-body">
    <sis-contextual-notification ng-if="$ctrl.workflow.initiatorType === 'STAFF'" variant="light">
      <span translate="STUDENT_APPLICATIONS.APPLICATION_CREATED_BY_STAFF" translate-value-person="{{$ctrl.initiatorPersonFullName}}"></span>
    </sis-contextual-notification>
    <div ng-if="!$ctrl.decision">
      <div class="row">
        <div class="col-md-12 situation-description">
          <p>
            <span
              ng-if="$ctrl.module.type !== 'GroupingModule'"
              translate="{{'HANDLE_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.approvalRequest.type + '.SITUATION_DESCRIPTION'}}"
              translate-value-modulename="{{ $ctrl.module.name | localizedString }}">
            </span>
            <span
              ng-if="$ctrl.module.type === 'GroupingModule'"
              translate="{{'HANDLE_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.approvalRequest.type + '.SITUATION_DESCRIPTION_FOR_GROUPING_MODULE'}}"
              translate-value-modulename="{{ $ctrl.module.name | localizedString }}">
            </span>
            <span
              translate="{{'HANDLE_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.approvalRequest.type + '.APPLIED_ON'}}"
              translate-value-applied-on="{{$ctrl.approvalRequest.creationTime | localDateFormat}}"></span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <module-content-application-structure
            module="$ctrl.module"
            selected-course-units="$ctrl.selectedCourseUnits"
            selected-course-unit-attainments-by-group-id="$ctrl.selectedCourseUnitAttainmentsByGroupId"
            selected-modules="$ctrl.selectedModules"
            selected-module-attainments-by-group-id="$ctrl.selectedModuleAttainmentsByGroupId"
            selected-custom-course-unit-attainments="$ctrl.selectedCustomCourseUnitAttainments"
            selected-custom-module-attainments="$ctrl.selectedCustomModuleAttainments"
            selected-grouping-modules="$ctrl.selectedGroupingModules"
            grade-scales-by-id="$ctrl.gradeScalesById"
            selected-custom-study-drafts="$ctrl.customStudyDrafts">
          </module-content-application-structure>
          <custom-study-draft-summary
            ng-repeat="customStudyDraft in $ctrl.customStudyDrafts track by customStudyDraft.id"
            custom-study-draft="customStudyDraft">
          </custom-study-draft-summary>
        </div>
      </div>
      <div class="row module-content-application-comment">
        <div class="col-md-6">
          <div class="form-group-mimic">
            <h4 translate="{{'HANDLE_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.approvalRequest.type + '.APPLICATION_RATIONALE'}}"
              >Perustelut anomukselle</h4
            >
            <span class="text-area-static">{{ $ctrl.approvalRequest.applicationRationale }}</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group-mimic">
            <h4 translate="STUDENT_APPLICATIONS.CANCELLING_DISABLED.LABEL"></h4>
            <span class="form-control-static">
              <span
                ng-if="$ctrl.workflow && $ctrl.workflow.cancellingDisabled === false"
                translate="STUDENT_APPLICATIONS.CANCELLING_DISABLED.FALSE"></span>
              <span
                ng-if="$ctrl.workflow && $ctrl.workflow.cancellingDisabled === true"
                translate="STUDENT_APPLICATIONS.CANCELLING_DISABLED.TRUE"></span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div ng-if="$ctrl.decision" class="show-with-decision">
      <div class="mca-border">
        <div class="accordion-panel accordion-panel-noblock">
          <div class="header">
            <a
              href
              class="collapse"
              ng-init="applicationCollapsed = false"
              ng-click="applicationCollapsed=!applicationCollapsed"
              ng-class="{collapsed: applicationCollapsed}"
              role="button"
              aria-hidden="true">
              <sis-icon [icon]="'chevron-ring-fill'" [icon-class]="!applicationCollapsed ? null : 'cw-90'"></sis-icon
            ></a>
            <div class="title" translate="STUDENT_APPLICATIONS.APPLICATION_INFO"></div>
          </div>
          <div class="content" ng-class="{'collapsed': applicationCollapsed}" ng-show="!applicationCollapsed">
            <div class="content-row">
              <div class="content-text">
                <div class="row">
                  <div class="col-md-12 situation-description">
                    <h3 translate="{{'HANDLE_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.approvalRequest.type + '.MODULE_CONTENT'}}"
                      >Opintokokonaisuuden poikkeava sisältö</h3
                    >
                    <p>
                      <span
                        ng-if="$ctrl.module.type !== 'GroupingModule'"
                        translate="{{'HANDLE_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.approvalRequest.type + '.SITUATION_DESCRIPTION'}}"
                        translate-value-modulename="{{ $ctrl.module.name | localizedString }}">
                      </span>
                      <span
                        ng-if="$ctrl.module.type === 'GroupingModule'"
                        translate="{{'HANDLE_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.approvalRequest.type + '.SITUATION_DESCRIPTION_FOR_GROUPING_MODULE'}}"
                        translate-value-modulename="{{ $ctrl.module.name | localizedString }}">
                      </span>
                      <span
                        translate="{{'HANDLE_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.approvalRequest.type + '.APPLIED_ON'}}"
                        translate-value-applied-on="{{$ctrl.approvalRequest.creationTime | localDateFormat}}"></span>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <module-content-application-structure
                      module="$ctrl.module"
                      selected-course-units="$ctrl.selectedCourseUnits"
                      selected-course-unit-attainments-by-group-id="$ctrl.selectedCourseUnitAttainmentsByGroupId"
                      selected-modules="$ctrl.selectedModules"
                      selected-module-attainments-by-group-id="$ctrl.selectedModuleAttainmentsByGroupId"
                      selected-custom-course-unit-attainments="$ctrl.selectedCustomCourseUnitAttainments"
                      selected-custom-module-attainments="$ctrl.selectedCustomModuleAttainments"
                      selected-grouping-modules="$ctrl.selectedGroupingModules"
                      grade-scales-by-id="$ctrl.gradeScalesById"
                      selected-custom-study-drafts="$ctrl.customStudyDrafts">
                    </module-content-application-structure>
                    <custom-study-draft-summary
                      ng-repeat="customStudyDraft in $ctrl.customStudyDrafts track by customStudyDraft.id"
                      custom-study-draft="customStudyDraft">
                    </custom-study-draft-summary>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group-mimic">
                      <h4 translate="{{'HANDLE_MODULE_CONTENT_APPROVAL_MODAL.' + $ctrl.approvalRequest.type + '.APPLICATION_RATIONALE'}}"
                        >Perustelut anomukselle</h4
                      >
                      <span class="text-area-static">{{ $ctrl.approvalRequest.applicationRationale }}</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group-mimic">
                      <h4 translate="STUDENT_APPLICATIONS.CANCELLING_DISABLED.LABEL"></h4>
                      <span class="form-control-static">
                        <span
                          ng-if="$ctrl.workflow && $ctrl.workflow.cancellingDisabled === false"
                          translate="STUDENT_APPLICATIONS.CANCELLING_DISABLED.FALSE"></span>
                        <span
                          ng-if="$ctrl.workflow && $ctrl.workflow.cancellingDisabled === true"
                          translate="STUDENT_APPLICATIONS.CANCELLING_DISABLED.TRUE"></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mca-border">
        <div class="accordion-panel accordion-panel-noblock">
          <div class="header">
            <a
              href
              class="collapse"
              ng-init="decisionCollapsed = false"
              ng-click="decisionCollapsed=!decisionCollapsed"
              ng-class="{collapsed: decisionCollapsed}"
              role="button"
              aria-hidden="true">
              <sis-icon [icon]="'chevron-ring-fill'" [icon-class]="!decisionCollapsed ? null : 'cw-90'"></sis-icon
            ></a>
            <div class="title" translate="STUDENT_APPLICATIONS.DECISION_INFO"></div>
          </div>
          <div class="content" ng-class="{'collapsed': decisionCollapsed}" ng-show="!decisionCollapsed">
            <div class="content-row">
              <div class="content-text">
                <module-content-application-decision-summary application="$ctrl.approvalRequest" decision="$ctrl.decision">
                </module-content-application-decision-summary>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div ng-if="$ctrl.approvalRequest.state === 'REQUESTED' || $ctrl.approvalRequest.state === 'IN_HANDLING'" class="modal-footer">
    <a
      href="/staff/studies/staff/transactions/student-applications/{{$ctrl.approvalRequest.id}}"
      class="btn btn-primary btn-lg"
      translate="SIS_COMPONENTS.COMMON_SHOW_MODULE_CONTENT_APPLICATION_MODAL.PROCEED_TO_HANDLE_APPLICATION">
      Siirry hakemuksen käsittelyyn
    </a>
  </div>
</div>
`;
export default template;
